import { render, staticRenderFns } from "./PriceConfigTable.vue?vue&type=template&id=0eb114a6&"
import script from "./PriceConfigTable.vue?vue&type=script&lang=ts&"
export * from "./PriceConfigTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports